import Drawer from '../../components/Drawer';
import GameCustomizePage from './GameCustomizePage';

export interface GameCustomizeDrawerProps {
  open: boolean;
  onClose: () => void;
}

export default function GameCustomizeDrawer({
  open,
  onClose,
}: GameCustomizeDrawerProps) {
  return (
    <Drawer open={open} onClose={onClose}>
      <GameCustomizePage />
    </Drawer>
  );
}
